import { MsisdnListInterface } from '../../models/msisdn-list.interface';

export interface MsisdnListInterfaceState {
  list: Array<MsisdnListInterface>;
}

export const initialMsisdnListState: MsisdnListInterfaceState = {
  list: null
};
